export const getrolesquery = `
   {
    allRoles {
      id
      role
      roleDescription
      roleGroupId
      roleGroup
      isActive
      statusFlag
      createdBy
      createdDate
      updatedBy
      updatedDate
      companyId
      
    }
  }
  `;
export const AllModules = `
    {
    allModules {
      id
        module
        isActive
        statusFlag
        createdBy
        createdDate
        updatedBy
        updatedDate
        icon
        displayOrder
    }
  }
  `;
export const allCasesDynamic = `{
  allCasesDynamicView {
    assignedTo
    caseNumber
    caseStatus
    categoryName
    clientType
    companyName
    createdBy
    createdDate
    dateClosed
    dateOpened
    description
    id
    isActive
    isInvoiced
    priority
    statusFlag
    subcategoryName
    summary
    title
    updatedBy
    updatedDate
  }
}`;

export const caseCategory = `{
  allCaseCategories {
    id
    categoryName
    description
    companyId
    
  }
}`;
export const caseSubCategory = `{

  allCaseSubcategories {
    id
    categoryId
    subcategoryName
    description
    companyId
    
  }
}`;

export const caseEvents = `
{
  allCaseEvents {
    id
    caseId
    eventTypeId
    eventType
    eventDate
    outcome
    hearingDate
    description
    createdBy
    createdDate
    companyId
    
  }
}
`;

export const caseTasks = `{
  allCaseTaskView {
    caseNumber
    companyName
    createdBy
    createdDate
    description
    dueDate
    id
    isActive
    name
    statusFlag
    updatedBy
    updatedDate
  }
}`;
export const allFacts = `{
  allFactView {
    caseNumber
    categoryName
    companyName
    createdBy
    createdDate
    factDate
    factDescription
    id
    updatedBy
    updatedDate
  }
}`;

export const allCasesEvents = `{
  allCaseEventsView {
    caseNumber
    companyName
    createdBy
    createdDate
    description
    eventDate
    eventType
    hearingDate
    id
    outcome
  }
}`;

export const allEventTypes = ` {
  allEventTypes {
      id
      eventType
      createdDate
      createdBy
      updatedBy
      updatedDate
      companyId
      
  }
}
`;

export const allIndividualClients = `
{
  allCustomers {
        id
        customerName
        phoneNumber
        customerLocation
        customerAlias
        customerPostalAddress
        customerNationalIdNumber
        companyName
        companyId
        email
        createdDate
        createdBy
        createdByName
        updatedDate
        updatedBy
        updatedByName
        isActive
        activatedDate
        activatedBy
        activatedByName
        discount
        customerTypeId
        customerTypeName
        creditApproved
        creditApprovedBy
        creditApprovedByName
        creditApprovedDate
        deactivatedDate
        deactivatedBy
        deactivatedByName
        customerBalance
  }
}
`;

export const allCorporateClients = `
{
  allCorporateClients {
    id
    contactNumber
    email
    address
    dateAdded
    notes
    companyName
    registrationNumber
    industrySector
    contactPersonName
    contactPersonPosition
    contactPersonEmail
    contactPersonPhone
    companyAddress
    billingAddress
    incorporationDate
    legalStructure
    countryOfIncorporation
    taxIdentificationNumber
    authorizedSignatoryName
    authorizedSignatoryPosition
    authorizedSignatoryEmail
    authorizedSignatoryPhone
    isActive
    statusFlag
    createdBy
    createdDate
    updatedBy
    updatedDate
    companyId
    
  }
}
`;
export const allUsersQuery = `{
    allUsers {
      id
      firstName
      username
      lastName
      idno
      phone
      gender
      email
      isActive
      roleName
    }
  }`;

export const allCourts = ` {
  allCourts {
    id
    court
    courtTypeId
    courtType
    countryId
    country
    countyId
    county
    subCountyId
    subCounty
    latitude
    longitude
    createdDate
    createdBy
    updatedBy
    updatedDate
    companyId
    
  }
  }`;

export const allCompanies = `{
  companies {
    id
    companyName
    subscriptionId
    contactPhoneNumber
    parentOffice
    tagLine
    active
    createdBy
    createdDate
    updatedBy
    updatedDate
  }
}`;

export const PaymentMethodQuery = `
{
  accountSubCategoryByCategoryId(functionparams: { accountCategoryId: 3 }) {
    id
    accountCategory
    accountNumber
    accountName
  }
}`;

export const ExpensePaymentMethodsQuery = `{
  paymentMethods {
    id
    methodName
    isActive
  }
}`;

export const allRegions = `{
    region {
        id
        regionName
        companyId
        company
        createdDate
        createdBy
        updatedBy
        updatedDate
    }
}`;

export const allCounties = `{
    allCounties {
      id
      county
      countyCode
      createdDate
      createdBy
      updatedBy
      updatedDate
    }
  }`;

export const allAccountTypes = ` 
  {
  allAccountTypes {
      id
      accountType
      
      companyId
    }
  } `;
export const allAccountCategories = `{
  accountCategory {
      id
      status
      categoryName
      currency
      rate
      parentAccount
      oldParent
      companyId
      
    }
  }
  `;
export const allAccountSubCategories = ` {
  accountSubCategory {
      accountCategory
      accountCategoryId
      accountName
      accountNumber
      accountType
      
      companyId
      currency
      id
      parentAccount
      rate
      status
    }
  }
  `;
export const allAccounts = ` {
  accounts {
      id
        displayName
        accountNumber
        accountType
        companyId
        company
        currencyId
        currency
        isActive
        statusFlag
        createdBy
        createdDate
        updatedBy
        updatedDate
        identifierType
        identifierId
        accountSubcategoryId
        accountCategoryId
        accountCategory
        subCategoryId
        subCategoryName
        balance
        rowType
        categorySortOrder
    }
  }
  `;
export const allSuspendedTransactions = ` {
   suspendedTxnsByCompanyId {
        id
        billRefNumber
        businessShortCode
        firstName
        lastName
        invoiceNumber
        middleName
        msisdn
        orgAccountBalance
        thirdPartyTransID
        transactionType
        transAmount
        transID
        transTime
        isReconcilled
        companyId
    }
    }
    `;
export const allPaymentTypes = `{
  allPaymentTypes {
      id
      paymentType
      
      companyId

    }
  }
  `;
export const allBanks = `{
  allBanks {
      id
      bankName
      bankSwiftCode
      finCode
      mobile
      createdDate
      createdBy
      email
      companyId
      
    }
  }

  `;

export const allMpesa = `{
  allMpesaProviders {
        id
        providerName
        shortCode
        businessCode
        contactNumber
        email
        companyId
        createdDate
        updatedDate
        createdBy
        updatedBy
    }
  }
  `;
export const allBankBranches = `{
  allBankBranches {
      id
      bankId
      branchCode
      branchName
      branchSwiftCode
      createdDate
      createdBy
      companyId
      
    }
  }

  `;
export const allBankBranchView = `{
    allBankBranches {
        id
        bankId
        bankName
        branchCode
        branchName
        branchSwiftCode
        createdDate
        createdBy
        companyId        
    }
}`;
export const allBankAccounts = `{
  allBankBranches {
      id
      bankId
      branchCode
      branchName
      branchSwiftCode
      createdDate
      createdBy
      companyId
      
    }
  }
  `;
export const allBanksBankBranchesAccountView = `{
    allBanksBranchAccountView {
        id
        bankId
        bankBranchId
        bankName
        branchName
        accountName
        accountNumber
        accountDescription
        status
        companyId
        companyName
    }
}`;
export const allFiscalYears = `{
  allFiscalYears {
      id
      fiscalYearName
      startDate
      endDate
      status
      createdDate
      createdBy
      companyId
      
    }
  }

  `;
export const allTaxAuthorities = `{
  allTaxAuthoritiesview {
    country
    id
    jurisdiction
    taxAuthorityName
  }
  }
  `;
export const allMpesaAccounts = `{
    allMpesaAccounts {
        id
        providerId
        providerName
        shortCode
        businessCode
        regionId
        regionName
        branchId
        branchName
        accountName
        tillPaybillNumber
        accountDescription
        status
        isSaleAccount
        companyId
        createdDate
        createdBy
        updatedDate
        updatedBy
    }
  }`;
export const allTaxRates = `{
  allTaxRatesView {
    country
    id
    name
    rate
    taxAuthorityName
  }
  }
  `;

export const allJudgesQuery = `
  {
  allJudges {
      
      companyId
      judgeId
      name
    }
  }
  `;

export const allCountries = `{
    allCountries {
      id
      country
      countryInitials
      createdDate
      createdBy
      updatedBy
      updatedDate
    }
  }`;
export const allCashAccounts = `{
   allCashAccounts {
        id
        regionId
        regionName
        branchId
        branchName
        accountName
        accountDescription
        isSaleAccount
        status
        companyId
        createdDate
        createdBy
        updatedDate
        updatedBy
    }
  }`;
export const AllMpesaProviders = `{
    allMpesaProviders {
        id
        providerName
        shortCode
        businessCode
        contactNumber
        email
        companyId
        createdDate
        updatedDate
        createdBy
        updatedBy
    }
  }`;
export const allBranches = `
{
  branch {
    id
    branchName
    createdDate
    createdBy
    updatedBy
    updatedDate
    companyId
    isWarehouse
    regionId
    region
  }
}
`;

export const allCompanyBranches = `
{
  allBranchesByColumnValues(branchModel: { companyId: 1 }) {
    id
    branchName
    createdDate
    createdBy
    updatedBy
    updatedDate
    companyId
    isWarehouse
    regionId
    region
    }
}
`;

export const allCompanyBranchesView = `{
    allBranchView {
        id
        branchName
        createdDate
        createdBy
        updatedBy
        companyId
        company
        regionId
        region
        isWarehouse
        location 
        building
        contacts
    }
}
`;
export const allUsers = `{
    allUsers {
      id
      firstName
      username
      lastName
      idno
      phone
      email
      isActive
      roleName
      roleId
      genderId
      regionId

      branchId
    }
}
`;
export const allDepartments = `{
  allDepartments {
    id
    departmentName
    createdDate
    createdBy
    updatedBy
    updatedDate
    companyId
    
  }
}`;
export const allAddOns = `
    {
  allAddOns {
    id
    addOnName
    description
    price
    isActive
    createdDate
    createdBy
    updatedBy
    updatedDate
  }
}
`;
export const allCompanyAddOns = `
  {
  allCompanyAddOns {
    id
    companyId
    addOnId
    addOn
    purchasedDate
    
    createdDate
    createdBy
    updatedBy
    updatedDate
  }
}

`;
export const allSubscriptionPlans = `
 {
  subscriptionPlans {
    id
    planName
    description
    price
    durationMonths
    storageLimit
    storageUnitId
    isActive
    createdDate
    createdBy
    updatedBy
    updatedDate
  }
}

`;
export const allStorageUnits = `
{
  allStorageUnits {
    id
    unit
    description
  }
}

`;
export const allSmsSettings = ` {
    smsSettings {
        companyId
        
        active
        promotionalAmount
        transactionalAmount
        smsLimit
    }
  }
`;
export const notificationsAndCount = `{
    notificationsByUser {
        count
        notifications {
            notificationId
            userId
            notificationType
            body
            templateId
            isRead
            createdDate
            companyId
            company
        }
    }
}
`;

export const allCaseTask = `{
    allCaseTasks {
      id
      caseId
      asigneeId
      description
      isActive
      statusFlag
      createdBy
      createdDate
      updatedBy
      updatedDate
      companyId
      
    }
  }`;
export const allCompanyEmailSettings = `{
  companyEmailSettingsById {
    companyId
    companyName
    companyEmail
    contactEmail
    contactEmailPassword
    emailClient
    emailClientPortNumber
    emailDisplayName
  }
}`;

export const allCourtAssignments = `{
    allCourtAssignments {
        id
        caseId
        courtId
        assignedDate
        createdBy
        createdDate
        companyId
        
    }
}`;

export const allCaseEvents = `{
    allCaseEvents {
        id
        caseId
        eventTypeId
        eventType
        eventDate
        outcome
        hearingDate
        description
        createdBy
        createdDate
        companyId
        
    }
}
`;

export const allJudgeAssignments = ` {
    allJudgeAssignments {
        id
        caseId
        judgeId
        assignedDate
        createdBy
        createdDate
        companyId
        
    }
}
`;

export const allTeamAssignment = `{
    allTeamAssignmentView {
      assignedDate
      caseNumber
      companyName
      createdBy
      createdDate
      id
      isActive
      statusFlag
      updatedBy
      updatedDate
      userName
    }
  }`;
export const allCaseStatus = ` {
    allCaseStatus {
        id
        status
    }
}`;
export const mainDashboardQuery = `
  {
    companySummary {
        team
        numberOfCases
        numberOfCourtCases
        numberOfCorporateClients
        numberOfIndividualClients
        numberOfCaseEvents
        numberOfCaseTasks
        numberOfNewClients
        corporateClientPercentage
        individualClientPercentage
        courtCasePercentage
        casesClosed
        matterCompletion
        taskCompletion
        }

}

`;
export const allCasesView = `{
    allCasesView {
        id
        clientType
        caseNumber
        title
        description
        summary
        categoryName
       clientTypeId
        subcategoryName
        caseStatus
        dateOpened
        dateClosed
        priority
        isActive
        statusFlag
        createdBy
        createdDate
        updatedBy
        updatedDate
        isInvoiced
        companyId
        
        regionId
        branchId
        individualFirstName
        individualLastName
        corporateCompanyName
        workFlow
        name
        clientId
        caseCategoryId
        caseSubCategoryId
    }
}`;
export const caseTaskForDashboard = `{
    recentCasesDynamic {
        id
        caseId
        asigneeId
        caseNumber
        title
        firstName
        lastName
        description
        caseDescription
        isActive
        done
        statusFlag
        dueDate
        createdDate
        regionId
        branchId
        companyId
        
    }
}`;

export const caseMonthlyCasesStatististics = `
{
  monthlyStatisticsByYear(year: 2024) {
    assignedCases
    assignedCasesColor
    closedCases
    closedCasesColor
    inprogressCases
    inprogressCasesColor
    month
    newCases
    newCasesColor
  }
}
`;
export const getStorageData = `
{
    storageData {
        storage
        value
        label
        color
    }
}`;

export const allAdhocSmS = `
{
    smSesByCompany {
        messageId
        phoneNumber
        body
        sentDateTime
        status
     
     
    }
}
`;
export const allAdhocEmails = `{
    emailsByCompany {
        messageId
        recipientEmail
        subjectTitle
        body
        sentDateTime
        status
     
    }
}
`;

export const allGenders = `
{
    allGenders {
        id
        gender
        createdDate
        createdBy
        updatedBy
        updatedDate
    }
}`;
export const allSubRights = `
 {
    allSubRights {
        id
        title
        icon
        action
        rightId
        isActive
        statusFlag
        createdBy
        createdDate
        updatedBy
        updatedDate
        companyId
        
    }
}`;
export const allRights = `{
    allRights {
       id
        title
        icon
        action
        moduleId
        module
        isActive
        statusFlag
        createdBy
        createdDate
        updatedBy
        updatedDate
        adminOnly
        
    }
}`;
export const allRoleGroups = `{
    allRoleGroups {
        id
        roleGroup
        isActive
        statusFlag
        createdBy
        createdDate
        updatedBy
        updatedDate
        companyId
             
    }
}
`;

export const recentCaseTasks = `
{
    recentCaseTasks(taskModel: { companyId: null }) {
        id
        description
        caseId
        caseTitle
        assigneeFirstName
        assigneeLastName
        isActive
        statusFlag
        dueDate
        createdDate
        asigneeId
        createdBy
        companyId
        done
    }
}`;
export const allProcessFlows = `{
    allRoleGroups {
        id
        roleGroup
     
    }
}
`;
export const allReportTypes = `
{
    reportTypesView {
        id
        majorClassificationID
        majorClassification
        minorClassificationID
        minorClassification
        reportName
        createdBy
        createdDate
        updatedBy
        updatedDate
    }
}
`;
export const allReportsMajorClassifications = `
    {
    reportsMajorClassifications {
        id
        majorClassification
        createdBy
        createdDate
        updatedBy
        updatedDate
    }
  }
  `;

export const allReportMinorClassifications = `
{
    reportsMinorClassificationsView {
        id
        majorClassificationID
        majorClassification
        minorClassification
        createdBy
        createdDate
        updatedBy
        updatedDate
    }
}`;
export const IntervalsQuery = `{
    intervals {
        id
        intervalName
        interval
        createdDate
        createdBy
        createdByName
        updatedDate
        updatedByName
        isActive
    }
}
`;
export const CustomerTypesQuery = `{
    customerTypes {
    createdBy
    createdByName
    createdDate
    typeName
    discountPercentage
    id
    updatedDate
    updatedByName
  }
}
`;
export const DiscountTypesQuery = `{
discountTypes {
    id
    name
    description
    isActive
    createdBy
    createdByName
    createdDate
    updatedByName
    updatedDate
  }
}`;
export const DiscountRulesQuery = `{
allDiscountRules {
    appliesToAllCustomers
    appliesToAllProducts
    branchId
    companyId
    discountFlatAmount
    discountPercentage
    discountTypeId
    id
    isActive
    minPurchaseAmount
    createdAt
    createdBy
    regionId
    updatedDate
    updatedBy
  }
}`;

export const SellingPriceRulesQuery = `{
    allSellingPricePercentageRules {
        id
        percentage
        updated_by
        created_by
        created_at
        updated_at
        companyid
    }
}`;
export const PaymentMethodsQuery = `
{
    paymentMethods {
        id
        methodName
        createdDate
        createdBy
        createdByName
        updatedDate
        updatedByName
        isActive
    }
}
`;
export const UOMQuery = `
{
    unitOfMeasure {
        id
        name
        unit
        createdDate
        createdBy
        createdByName
        updatedDate
        updatedByName
        isActive
    }
}`;
export const ProductCategoryQuery = `
{
    productCategory {
        id
        name
        createdDate
        createdBy
        createdByName
        updatedDate
        updatedByName
        isActive
    }
}`;

export const AllVendors = `
{
    allVendors {
        id
        vendorName
        contactPerson
        phoneNumber
        address
        createdDate
        createdBy
        updatedDate
        updatedBy
        isActive
        companyId
        isInternal
        branchId
        balance
    }
}`;

export const AllSaleOrders = `
{
   allSaleOrdersView {   
      id   
      saleOrderId
      customerId
      customerName
      phoneNumber
      branchName
      paymentMethodId
      paymentMethod
      isPaid
      createdDate
      createdBy
      salesAgent
      modifiedBy
      updatedDate
      updatedBy
      companyId
      companyName
      cancelled
      customerBalance
      outstanding
      totalAmount
      saleDate
      isCredit
      isInvoiced
      branchId
      reversed
    }
}`;

export const ReversedSaleorders = `{
    allReversedSaleOrdersView {
        saleOrderId
        saleDate
        customerId
        customerName
        phoneNumber
        totalAmount
        isPaid
        createdDate
        createdBy
        updatedDate
        updatedBy
        modifiedBy
        addedBy
        companyId
        companyName
        regionId
        branchId
        cancelled
        isCredit
        isInvoiced
        customerTypeId
        typename
        branchName
        outstanding
        reason
    }
}`;


export const AllSaleOrderItemViews = `
{
  allSaleOrderItemViews {
    id
    saleOrder
    customerId
    customerName
    productId
    productName
    amount
    uomId
    unitofMeasure
    quantity
    companyId
    regionId
    branchId
    companyName
    createdBy
    updatedBy
    createdDate
    updatedDate
  }
}`;

/**
 * Payment Voucher Queries
 */
export const AllPaymentVouchers = `
 {
    allPaymentVouchersView {
        paymentVoucherId
        purchaseOrderId
        vendorName
        paymentMethod
        methodName
        paymentAccountId
        accountName
        paidAmount
        outstandingBalance
        vendorId
        reference
        remarks
        paymentDate
        isActive
        creator
        approver
        createdDate
        approvedDate
        updatedDate
        updator
        companyId
        rejectedBy
        rejectedDate
        branchName
        reason
        actionBy
        actionedDate
    }
}
`;

export const AllPaymentVouchersView = `
  query AllPaymentVouchersView(
    $id: Int
    $branchid: Int
    $paymentstatus: Int
    $startDate: DateTime
    $endDate: DateTime
    $pagination: Int
    $searchParam: String
  ) {
    allPaymentVouchersView(
      paymentVoucherFilter: {
        id: $id
        branchid: $branchid
        paymentstatus: $paymentstatus
        startDate: $startDate
        endDate: $endDate
        pagination: $pagination
        searchParam: $searchParam
      }
    ) {
      paymentVoucherId
      purchaseOrderId
      vendorName
      paymentMethod
      methodName
      paymentAccountId
      accountName
      paidAmount
      outstandingBalance
      vendorId
      reference
      remarks
      paymentDate
      isActive
      creator
      approver
      createdDate
      approvedDate
      updatedDate
      updator
      companyId
      rejectedBy
      rejectedDate
      branchName
      reason
      actionBy
      actionedDate
    }
  }
`;
export const paymentvouchersearch = `
  query AllPaymentVouchersView($parameters: paymentvoucherpaginationInput) {
    allPaymentVouchersView(paymentVoucherFilter: $parameters) {
        paymentVoucherId
        purchaseOrderId
        vendorId
        vendorName
        paymentMethod
        methodName
        paymentAccountId
        accountName
        paidAmount
        outstandingBalance
        paymentDate
        reference
        remarks
        isActive
        createdBy
        creator
        approvedBy
        approver
        createdDate
        approvedDate
        updatedDate
        updatedBy
        updator
        companyId
        rejectedBy
        rejectedDate
        branchName
        reason
        actionBy
        actionedDate
        totalRecords
        currentPage
        pageSize
        totalPages
        firstRecordInPage
        lastRecordInPage
    }
}
`;
/*
once published
add
to allsaleOrdersView
customerBalance
*/

export const AllSaleOrderItemsViews = `
 {
    allSaleOrderItemViews {
        id
        saleOrder
        customerId
        customerName
        productId
        productName
        productCode
        amount
        uomId
        unitofMeasure
        quantity
        companyId
        companyName
        createdBy
        updatedBy
        createdDate
        updatedDate
    }
}

`;

export const AllPurchaseOrders = `
{
  allPurchaseOrders {
        id
        vendorId
        orderDate
        totalAmount
        paymentStatus
        deliveryStatus
        createdDate
        createdBy
        updatedDate
        updatedBy
        companyId
        isActive
    }
}
`;
export const AllPurchaseOrdersView = `
{
    allPurchaseOrdersView {
        id
        purchaseOrder
        vendorName
        vendorComments
        vendorId
        orderDate
        totalAmount
        branchName
        paymentStatus
        deliveryStatus
        productCode
        createdDate
        createdBy
        updatedDate
        expiryDate
        updatedBy
        companyId
        companyName
        isActive
        outstandingBalance
        addedBy
        modifiedBy
        branchId
        reversed
    }
}

`;
export const AllPurchaseOrdersReverseView = `
{
    allPurchaseOrdersReverseView {
        id
        purchaseOrder
        vendorName
        vendorComments
        vendorId
        orderDate
        totalAmount
        branchName
        paymentStatus
        deliveryStatus
        productCode
        createdDate
        createdBy
        updatedDate
        expiryDate
        updatedBy
        companyId
        companyName
        isActive
        outstandingBalance
        addedBy
        modifiedBy
        branchId
        reversed
    }
}

`;
export const AllPurchaseOrderItemsViews = `
{
  allPurchaseOrderItemViews {
      id
        purchaseOrderId
        productId
        productName
        orderDate
        expiryDate
        amount
        uomId
        cartons
        unitOfMeasure
        quantity
        createdDate
        createdBy
        updatedDate
        updatedBy
        isActive
        companyId
        regionId
        branchId
        companyName
        vendorId
        vendorName
  }
}
`;
export const AllPurchaseOrderItems = `
{
  allPurchaseOrderItems {
        id
        vendorId
        purchaseOrderId
        productId
        orderDate
        expiryDate
        amount
        uomId
        cartons
        maxShoeSize
        minShoeSize
        quantityPerCarton
        buyingPricePerCarton
        sellingPricePerCarton
        productCode
        stockDueDate
        reorderPoint
        colorId
        createdDate
        createdBy
        updatedDate
        updatedBy
        isActive
        companyId
        regionId
        branchId
        buyingPricePairs
        sellingPricePairs
  }
}
`;

// Query for purchase order items with stock due date (for due stock tracking)
export const PurchaseOrderItemsWithDueDate = (branchId) => `
{
  allPurchaseOrderItems {
        id
        purchaseOrderId
        productId
        productCode
        stockDueDate
        isActive
        branchId
        companyId
  }
}
`;
export const AllWarehouseInventory = `
{
    allWarehouseInventory {
        id
        productCode
        productId
        aliasProductName
        cartons
        buyingPricePerCarton
        totalValue
        branchId
        regionId
        companyId
        createdBy
        createdDate
        updatedBy
        updatedDate
        quantityPerCarton
        isActive
    }
}
`;
export const inventoryQuery = `
{
    allInventoryView {
        id
        productId
        productName
        branchName
        productCode
        aliasProductName
        cartons
        quantityPerCarton
        averageBuyingPrice
        averageSellingPrice
        totalValue 
        quantity
        createdDate
        createdByName
        updatedDate
        updatedByName
        branchId
        companyId
        isActive
        isDistributed
        realStockDueDate
    }
}
`;
export const retailInventoryQuery = `
{
   retailInventory {
    averageBP
    averageCost
    averageSP
    branchId
    buyingPrice
    cartons
    colorId
    companyId
    createdBy
    createdDate
    expectedProfit
    id
    lastUpdated
    newBuyingPrice
    newSellingPrice
    productCode
    productId
    purchaseOrderItemsId
    quantity
    regionId
    sellingPrice
    sizeId
    totalValue
    updatedBy
    updatedDate
    isDistributed
  }
}
`;
export const AllProducts = `
{
allProducts {
      id
      productName
      uomId
      unitPrice
      costPrice
      isActive
      reorderPoint
      isInventory
      createdDate
      createdBy
      updatedDate
      updatedBy
      retailPrice
      wholesalePrice
      isService
  }
}`;
export const allProductsViews = `
{
   allProductViews {
        id
        productName
        productCategory
        unitPrice
        costPrice
        retailPrice
        wholesalePrice
        isActive
        reorderPoint
        createdDate
        updatedDate
        uomId
        createdByName
        updateByName
        isService
    }
}`;
export const allFixedEntriesView = `
{
      allFixedEntriesView {
      id
      entry
      intervalId
      intervalName
      accountName
      description
      amount
      createdDate
      createdBy
      updatedDate
      updatedBy
      isActive
      accountSubCategoryId 
      companyId
    }
}`;

export const AlProducts = `{
  allProducts {
      id
      productName
      unitPrice
      costPrice
      isActive
      reorderPoint
      isInventory
      createdDate
      createdBy
      updatedDate
      updatedBy
  }
}
`;

export const allProducts = `{
allProducts {
      id
      productName}`;

//Dashboard Data
export const SalesCard = `{
    salesCard {
        percentageChange
        currentMonth
        lastMonth
    }
}`;

export const CustomersCard = `{
  customersCard {
        percentageChange
        currentMonth
        lastMonth
    }
}`;

export const ExpensesCard = `{
   expensesCard {
        percentageChange
        currentMonth
        lastMonth
    }
}`;

export const RevenueCard = `{
  revenueCard {
        percentageChange
        currentMonth
        lastMonth
    }
}`;

export const RevenueTrend = `{
revenueTrend {
  value
  monthName
}
}`;

export const SalesTrend = `{
   salesTrend {
        value
        monthName
    }
 }`;

export const SoldProductsChart = `{
  soldProductsChart {
        value
        name
    }
}`;
export const AllProductViews = `{
  allProductViews {
      id
      productName
      productCategory
      unitPrice
      costPrice
      isActive
      reorderPoint
      isInventory
      createdDate
      createdBy
      updatedDate
      updatedBy
      isHotel
      companyId
      companyName
      uomId
      unitofMeasure
      inventoryQuantity
      retailPrice
      wholesalePrice
  }
}`;
export const AllInventoryViews = `{
  allInventoryViews {
      id
      productName
      productCategory
      unitPrice
      costPrice
      isActive
      reorderPoint
      isInventory
      createdDate
      createdBy
      updatedDate
      updatedBy
      isHotel
      companyId
      companyName
      uomId
      unitofMeasure
      inventoryQuantity
      retailPrice
      wholesalePrice
  }
}`;
export const AllInventoryView = `{
    allInventoryView {
        id
        productId
        productName
        branchName
        productCode
        aliasProductName
        cartons
        quantityPerCarton
        averageBuyingPrice
        averageSellingPrice
        totalValue 
        quantity
        createdDate
        createdByName
        branchId
        companyId
        isActive
        isDistributed
        buyingPrice
        sellingPrice
       
    }
}`;
export const allwarehouseinventory = `{
    allWarehouseInventory {
        id
        productCode
        productId
        cartons
        buyingPricePerCarton
        totalValue
        branchId
        regionId
        companyId
        createdBy
        createdDate
        updatedBy
        updatedDate
        isActive
    }
}`;

export const allwarehouseinventorybyid = `{
    
    warehouseInventoryById(
        warehouseInventory: {
            isActive: null
            updatedDate: null
            updatedBy: null
            createdBy: null
            createdDate: null
            branchId: null
            regionId: null
            companyId: null
            totalValue: null
            buyingPricePerCarton: null
            cartons: null
            productId: null
            id: null
            productCode: null
        }
    ) {
        id
        productCode
        productId
        cartons
        buyingPricePerCarton
        totalValue
        branchId
        regionId
        companyId
        createdBy
        createdDate
        updatedBy
        updatedDate
        isActive
    }


}`;
export const allwarehouseinventoryview = `{
        warehouseInventoryView {
        id
        productCode
        productName
        productId
        aliasProductName
        cartons
        averageBP
        averageSP
        branchName
        branchId
        regionId
        companyId
        createdByName
        updatedByName
        createdDate
        updatedDate
        isActive
        averageBpPerPair
        averageSPPerPair
    }
}`;

export const allwarehousedistribution = `{
        warehouseDistribution {
        id
        purchaseOrderId
        productCode
        branchId
        colorId
        sizeRange
        minSize
        maxSize
        quantity
        averageCost
        createdDate
        companyId
        regionId
    }
}`;

export const AllRetailDistribution = ` {
    allRetailDistribution {
        id
        purchaseOrderId
        productCode
        branchId
        colorId
        colorName
        size
        quantity
        createdDate
        productId
        productName
        updatedByName 
        updatedDate 
        createdByName 
        stockDueDate 
        companyId
        retailPurchaseOrderItemsId
        warehousePurchaseOrderItemsId
        warehousePurchaseOrderId
    }
}`;

export const externalProductsQuery = `{
    allExternalProducts {
        id
        product
        productCode
        amount
        color
        size
        createdBy
        createdDate
        updatedBy
        updatedDate
        branchId
        branchName
        regionId
        companyId
        quantity
        totalAmount
        externalPaymentStatus
    }
}

`;

export const ColorsQuery = `{
    color {
      id
      name
      createdDate
      createdBy
      createdByName
      updatedDate
      updatedByName
      isActive
    }
  }
`;

export const SizeQuery = `{
  size {
    id
    name
    createdDate
    createdBy
    createdByName
    updatedDate
    updatedByName
    isActive
  }
}
`;
export const CartItemsByUser = `{
    cartItemsByUser {
        id
        userId
        branchId
        companyId
        isWarehouseMode
        productId
        productCode
        productName
        aliasProductName
        colorId
        colorName
        size
        sizeRange
        quantity
        isWarehouse
        uomId
        averageCost
        sellingPricePerCarton
        averageBP
        averageSP
        averageSellingPrice
        totalPrice
        isExternal
        isExternalBranch
        externalProductData
        inventoryDetailId
        quantityPerCarton
        isWholesale
        isDiscount
        discountValue
        createdDate
        updatedDate
    }
}`;
export const allAccountTransfersView = `
  query {
    allAccountTransfersView {
      id
      entryDate
      description
      accountFromType
      accountFromTypeNumber
      accountFromId
      accountFromName
      accountToType
      accountToTypeNumber
      accountToId
      accountToName
      amount
      createdBy
      createdByName
      createdDate
      updatedBy
      updatedByName
      updatedDate
      isApproved
      approvedBy
      approvedByName
      approvedDate
      companyId
      referenceNumber
      isActive
    }
  }
`;

export const SearchWarehouseInventory = (params) => `{
  searchWarehouseInventory(functionparams: { 
    branchId: ${params.branchId || 0}, 
    searchTerm: ${JSON.stringify(params.search || "")}, 
    pageNumber: ${params.pageNumber || 1}, 
    pageSize: ${params.limit || 50} 
  }) {
    items {
      id
      productCode
      productName
      productId
      cartons
      quantityPerCarton
      buyingPricePerCarton
      sellingPricePerCarton
      totalValue
      branchName
      branchId
      regionId
      companyId
      aliasProductName
      createdByName
      updatedByName
      createdDate
      updatedDate
      averageSP
      averageBP
      averageBpPerPair
      averageSPPerPair
      isActive
      expectedProfit
      totalRows
    }
    totalCount
  }
}`;

export const SearchWarehouseDistribution = (params) => `{
  searchWarehouseDistribution(functionparams: { 
    branchId: ${params.branchId || 0}, 
    searchTerm: ${JSON.stringify(params.search || "")}, 
    pageNumber: ${params.pageNumber || 1}, 
    pageSize: ${params.limit || 50} 
  }) {
    items {
      id
      purchaseOrderId
      productCode
      branchId
      companyId
      regionId
      colorId
      sizeRange
      minSize
      maxSize
      quantity
      averageCost
      createdDate
      createdBy
      totalRows
    }
    totalCount
  }
}`;

export const SearchRetailDistribution = (params) => `{
  searchRetailDistribution(functionparams: { 
    branchId: ${params.branchId || 0}, 
    searchTerm: ${JSON.stringify(params.search || "")}, 
    pageNumber: ${params.pageNumber || 1}, 
    pageSize: ${params.limit || 50} 
  }) {
    items {
      id
      purchaseOrderId
      productName
      productCode
      branchId
      branchName
      colorId
      colorName
      size
      quantity
      averageCost
      createdDate
      createdBy
      productId
      productCategory
      companyId
      totalRows
      updatedByName
      updatedDate
      stockDueDate
      createdByName
    }
    totalCount
  }
}`;

// Stats queries for banner totals (fetched separately from paginated data)
export const GetWarehouseInventoryStats = (branchId) => `{
  warehouseInventoryStats(functionparams: { branchId: ${branchId || 0} }) {
    totalCartons
    totalItems
    totalExpectedProfit
    totalValue
    activeProducts
  }
}`;

export const GetWarehouseDistributionStats = (branchId) => `{
  warehouseDistributionStats(functionparams: { branchId: ${branchId || 0} }) {
    totalDistributions
    totalCartons
    totalCost
    uniqueProducts
    todayDistributions
    weekDistributions
  }
}`;

export const GetRetailDistributionStats = (branchId) => `{
  retailDistributionStats(functionparams: { branchId: ${branchId || 0} }) {
    totalDistributions
    totalQuantity
    uniqueProducts
    uniqueBranches
    todayDistributions
    weekDistributions
  }
}`;


// Server-side statistics query - fetches totals across all data (not affected by pagination)
export const inventoryStatsQuery = (params) => `{
  retailInventoryStatistics(
    functionparams: {
      branchId: ${params.branchId || null}
      status: "${params.status || 'all'}"
      distribution: "${params.distribution || 'all'}"
    }
  ) {
    totalPairs
    totalProducts
    averagePrice
    activeItems
    distributedItems
    notDistributedItems
    expectedProfit
    totalSellingValue
    totalBuyingValue
  }
}`;

// Server-side search and paginated inventory query
export const SearchRetailInventory = ({
  searchTerm,
  limit,
  offset,
}) => `{
  searchRetailInventory(functionparams: {
    searchTerm: ${JSON.stringify(searchTerm || "")},
    limit: ${limit || 25},
    offset: ${offset || 0}
  }) {
    items {
      id
      productCode
      productId
      productName
      branchId
      branchName
      regionId
      companyId
      quantity
      cartons
      quantityPerCarton
      aliasProductName
      averageBP
      averageSP
      totalValue
      isActive
      isDistributed
      minSize
      maxSize
      createdDate
      updatedDate
      createdByName
      realStockDueDate
      totalCount
    }
    totalCount
  }
}
`;
